<template>
  <svg :width="width" :height="height" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="35" height="35" rx="17.5" fill="#4BB8D0" fill-opacity="0.2" />
    <rect x="2.5" y="2.5" width="30" height="30" rx="15" fill="#166ED4" fill-opacity="0.1" />
    <path
      d="M14.9393 21.5906L18.5979 17.0451M18.5979 17.0451L14.9393 12.4996M18.5979 17.0451H9.81738M18.5979 8.86328H21.5247C21.9128 8.86328 22.285 9.05484 22.5595 9.39581C22.8339 9.73679 22.9881 10.1993 22.9881 10.6815V23.4087C22.9881 23.8909 22.8339 24.3534 22.5595 24.6944C22.285 25.0354 21.9128 25.2269 21.5247 25.2269H18.5979"
      stroke="#06338E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ width?: string | number; height?: string | number }>(), {
  width: '35',
  height: '35',
});
</script>
